import { CloseIcon } from '@assets/icons';
import { Button, Modal } from 'antd';
import { AppPrimaryButton } from '@components/ui/AppPrimaryButton/AppPrimaryButton';
import styles from './AppConfirmationModalBase.module.css';

type AppConfirmationModalBaseProps = {
  open: boolean;
  title: string;
  descriptionLines?: string[];
  confirmText: string;
  cancelText: string;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
  modalClassName?: string;
};

export const AppConfirmationModalBase = ({
  open,
  title,
  descriptionLines = [],
  confirmText,
  cancelText,
  onCancel,
  onConfirm,
  isLoading = false,
  modalClassName,
}: AppConfirmationModalBaseProps) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={
        <div>
          <span className={styles.title}>{title}</span>
          <div className={styles.divider} />
        </div>
      }
      footer={null}
      destroyOnHidden
      maskClosable={!isLoading}
      closeIcon={<CloseIcon className={styles.close} />}
      className={modalClassName}
      classNames={{
        mask: styles.mask,
        content: styles.content,
        header: styles.header,
        body: styles.body,
      }}
    >
      <div className={styles.stack}>
        {descriptionLines
          .filter(Boolean)
          .map((line, index) => (
            <div key={`${line}-${index}`} className={styles.description}>
              {line}
            </div>
          ))}

        <div className={styles.actions}>
          <Button className={styles.cancelButton} onClick={onCancel} disabled={isLoading}>
            {cancelText}
          </Button>
          <AppPrimaryButton
            type="primary"
            className={styles.confirmButton}
            onClick={onConfirm}
            loading={isLoading}
          >
            {confirmText}
          </AppPrimaryButton>
        </div>
      </div>
    </Modal>
  );
};
